<template>
  <b-modal
    id="modal-stage-info"
    ok-title="Submit"
    cancel-variant="outline-secondary"
    centered
    body-class="common_modal modal_visible"
    hide-footer
    no-close-on-backdrop
    size="lg"
    hide-header-close
  >
    <!-- @hide="resetModal" -->
    <template #modal-header="{ close }">
      <h3 class="m-0">
        <font-awesome-icon class="mr-50" icon="fa-solid fa-clock" />新增進度詳情
      </h3>
      <a @click="close()">
        <font-awesome-icon style="font-size: 20px" icon="fas fa-times" />
      </a>
    </template>

    <div>
      <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
        <b-overlay
          :show="loading"
          spinner-variant="primary"
          spinner-type="grow"
          spinner-small
          rounded="sm"
        >
          <b-form class="mt-1" @submit.prevent="handleSubmit(onSubmit)">
            <b-row>
              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_info_date"
                >
                  <b-form-group
                    :label="`日期：`"
                    label-for="info-data-info_date"
                    label-cols-md="3"
                    class="required"
                  >
                    <flat-pickr
                      id="info-data-info_date"
                      v-model="newInfoData.info_date"
                      :config="{
                        allowInput: true,
                        altInput: true,
                        altFormat: 'Y-m-d',
                        dateFormat: 'Y-m-d',
                      }"
                      placeholder="輸入YYYY-MM-DD"
                    />
                    <b-form-invalid-feedback
                      :state="getValidationState(validationContext)"
                    >
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_info_title"
                >
                  <b-form-group
                    label="主題："
                    label-for="info-data-title"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="info-data-title"
                      v-model="newInfoData.title"
                      placeholder="輸入主題"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>

              <b-col cols="12" md="6">
                <validation-provider
                  #default="validationContext"
                  name="此欄"
                  rules="required"
                  vid="v_info_description"
                >
                  <b-form-group
                    label="內容："
                    label-for="info-data-description"
                    label-cols-md="3"
                  >
                    <b-form-input
                      id="info-data-description"
                      v-model="newInfoData.description"
                      placeholder="輸入內容"
                      :state="getValidationState(validationContext)"
                    />
                    <b-form-invalid-feedback>
                      {{ validationContext.errors[0] }}
                    </b-form-invalid-feedback>
                  </b-form-group>
                </validation-provider>
              </b-col>
              <b-col cols="12">
                  <upload-file
                  :key="`stage_info_modal_${newInfoData.id || 'new'}`"
                  :custome_id="`stage_info_modal_${newInfoData.id || 'new'}`"
                  :props_previewImage="newInfoData.files"
                  v-on:file-uploaded="onFileUploaded"
                  v-on:file-deleted="onFileDeleted"
                  file_delete_url="/project_stages/info/files"
                ></upload-file>
              </b-col>
            </b-row>
            <hr />
            <div class="d-flex mt-2 justify-content-end">
              <b-button
                v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                type="button"
                variant="outline-danger"
                class="mr-1"
                @click="hide"
              >
                取消
              </b-button>
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                type="submit"
              >
                <font-awesome-icon
                  class="mr-25"
                  icon="fa-solid fa-circle-check"
                />
                提交
              </b-button>
            </div>
          </b-form>
        </b-overlay>
      </validation-observer>
    </div>
  </b-modal>
</template>

<script>
import {
  BButton,
  BModal,
  VBModal,
  BCardText,
  BOverlay,
  BForm,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BRow,
  BCol,
  BCard,
  BCardBody,
  BFormInvalidFeedback,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import flatPickr from "vue-flatpickr-component";
import store from "@/store";
import { required } from "@validations";
import { ref, watch, onUnmounted } from "@vue/composition-api";
import { ValidationProvider, ValidationObserver, localize } from "vee-validate";
import zh_CN from "vee-validate/dist/locale/zh_CN.json";
localize("zh_cn", zh_CN);
import formValidation from "@core/comp-functions/forms/form-validation";
import AppTimeline from "@core/components/app-timeline/AppTimeline.vue";
import AppTimelineItem from "@core/components/app-timeline/AppTimelineItem.vue";
import uploadFile from "@/layouts/components/file/uploadFile.vue";

export default {
  components: {
    BButton,
    BModal,
    VBModal,
    BCardText,
    BOverlay,
    BForm,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BRow,
    BCol,
    BCardBody,
    BCard,
    BFormInvalidFeedback,
    AppTimeline,
    AppTimelineItem,
    vSelect,
    flatPickr,
    ValidationProvider,
    ValidationObserver,
    uploadFile,
  },
  directives: {
    "b-modal": VBModal,
    Ripple,
  },
  props: {
    infoData: {
      type: Object,
      required: false,
      default: () => ({ id: 0 }),
    },
  },
  data() {
    return {
      required,
    };
  },
  methods: {
    hide() {
      this.$bvModal.hide("modal-stage-info");
    },
    onFileUploaded(files) {
      // 新選取的檔案另存一個欄位。
      // 不可寫回 newInfoData.files —— 那個欄位同時綁在 upload-file 的
      // props_previewImage 上，寫回去會把預覽清單洗成一堆空白的「已有文件」。
      this.$set(this.newInfoData, "image_files", files);
    },
    onFileDeleted(id) {
      if (Array.isArray(this.newInfoData.files)) {
        this.newInfoData.files = this.newInfoData.files.filter(
          (ele) => ele.id !== id
        );
      }
      this.$emit("refetch-data");
    },
    resetModal() {
      this.newInfoData = { id: 0 };
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    onSubmit() {
      this.$swal({
        title: "你確定嗎?",
        showCancelButton: true,
        confirmButtonText: "提交",
        cancelButtonText: "取消",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.loading = true;
          const formData = new FormData();
          formData.append("id", this.newInfoData.id);
          formData.append("project_stage_id", this.newInfoData.project_stage_id);
          formData.append("info_date", this.newInfoData.info_date);
          formData.append("title", this.newInfoData.title);
          formData.append("description", this.newInfoData.description);
          const pendingFiles = this.newInfoData.image_files || [];
          pendingFiles.forEach((item) => {
            formData.append("image_files[]", item);
          });
          formData.append("expected_file_count", pendingFiles.length);
          store
            .dispatch("order/editProjectStageInfo", formData)
            .then((response) => {
              this.loading = false;
              const incomplete = response.data.upload_incomplete === true;
              this.$swal({
                text: response.data.message,
                icon: incomplete ? "warning" : "success",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
              this.$set(this.newInfoData, "image_files", []);
              this.$emit("refetch-data");
              this.hide();
            })
            .catch((error) => {
              this.loading = false;
              this.$swal({
                text: error.response.data.message,
                icon: "error",
                confirmButtonText: "確定",
                customClass: {
                  confirmButton: "btn btn-primary",
                },
                showClass: {
                  popup: "animate__animated animate__bounceIn",
                },
                buttonsStyling: false,
              });
            });
        }
      });
    },
  },
  setup(props) {
    const loading = ref(false);
    const newInfoData = ref({
      id: 0,
    });

    const resetInfoData = () => {
      newInfoData.value = JSON.parse(
        JSON.stringify({
          id: 0,
        })
      );
    };

    watch(
      () => props.infoData,
      (newVal) => {
        newInfoData.value = newVal ? { ...newVal } : { id: 0 };
      },
      { immediate: true }
    );

    const { refFormObserver, getValidationState, resetForm } =
      formValidation(resetInfoData);

    return {
      loading,
      newInfoData,
      refFormObserver,
      getValidationState,
      resetForm,
    };
  },
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
